import { createRoot } from 'react-dom/client';
import './App.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createMsalInstance } from './features';
import { getAppSettings } from './services';
import { Provider } from 'react-redux';
import { MsalProvider } from '@azure/msal-react';
import { SignalRProvider } from './services/signalR/signalRContext';
import { store } from './store';
import { IPublicClientApplication } from '@azure/msal-browser';
import { IAppSettings } from './model';

async function bootstrap() {
  const config = await getAppSettings();
  const instance = await createMsalInstance(config);

  render(config, instance);
}

function render(config: IAppSettings, instance: IPublicClientApplication) {
  const container = document.getElementById('root') as HTMLElement;
  const root = createRoot(container);

  root.render(
    <Provider store={store}>
      <MsalProvider instance={instance}>
        <SignalRProvider>
          <App settings={config} />
        </SignalRProvider>
      </MsalProvider>
    </Provider>,
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}

bootstrap().catch((error) => console.error(error));
